


import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Link, useLocation, useHistory } from "react-router-dom";
import { Menu, X } from 'lucide-react';
import { TbWorld } from "react-icons/tb";
import { ChevronRight, Headphones } from 'lucide-react';
import { addNewStyle, API, CRISTP_ID, wait } from '../../../../Helper';
import { IoIosArrowDown, IoIosArrowForward } from 
"react-icons/io";
import axios from 'axios';

const REACT_APP_LG_LOGO = process.env.REACT_APP_LG_LOGO
const REACT_APP_SM_LOGO = process.env.REACT_APP_SM_LOGO


const ToggleButton = styled.button`
  position: fixed;
  top: 10px;
  left: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;
`;

const SidebarContainer = styled.nav`
  background-color: rgb(30, 32, 36);
  width: ${props => props.isCollapsedMobile ? '100%' : '0px'};
  height: 100vh;
  padding:0px;
  color: #ffffff;
  transition: all 0.3s ease;
  overflow-y: auto;
  position: fixed;
  top:0;
  left: 0;
  z-index:1000;
  transform: ${props => props.isCollapsedMobile ? 'translateX(0)' : 'translateX(-100%)'};
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: ${props => props.isCollapsedMobile ? 'block' : 'none'};
`;

// const MenuItemLink = styled(Link)`
//   display: flex;
//   align-items: center;
//   background-color:#000;
//   color: ${(props) => (props.color ? props.color : '#ffffff')};
//   padding: 4px 8px;
//   cursor: pointer;
//   // border:1px solid red;
//     margin:4px 0;
//   position: relative;
//   // border-top-right-radius: 20px;
//   // border-bottom-right-radius: 20px;
//   text-decoration: none;

//   ${(props) =>
//     props.active &&
//     `
//     // &::before {
//     //   content: '';
//     //   position: absolute;
//     //   left: 0;
//     //   top: 0;
//     //   bottom: 0;
//     //   width: 60%;
//     //   background-color: rgba(76,175,80,0.2);
//     //   border-top-right-radius: 20px;
//     //   border-bottom-right-radius: 20px;
//     // }
//   `}
// `;

const MenuItemLink = styled(Link)`
   display: flex;
    align-items: center;
    color: ${(props) => (props.color ? 'white' : 'white')};

    padding: ${props => props.isCollapsed ? '2px' : '2px 8px'};
    cursor: pointer;
    position: relative;
    margin-top: 8px;
    // border:1px solid green;
    margin:${props => props.isCollapsed ? '5px 3px' : '3px 7px'};
    border-radius:5px;
    background-color:rgb(41, 45, 46) !important;
    width:97%;
    // border-top-right-radius: 20px;
    // border-bottom-right-radius: 20px;
    text-decoration: none;
    font-weight: ${(props) => (props.isVIP || props.isPromotion ? 'bold' : 'normal')};
    font-style: ${(props) => (props.isVIP ? 'italic' : 'normal')};

  ${(props) =>
    props.active &&
    `
      &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          color:white;
          // border:1px solid green;
          border-radius:5px;
          // margin:0px 5px;
          background: linear-gradient(to left, rgb(50, 55, 56), rgb(55, 99, 80));
          // background-color: rgba(76,175,80,0.2);
          // border-top-right-radius: 20px;
          // border-bottom-right-radius: 20px;
  `}
 

    ${(props) =>
      props.isCollapsed &&
      `
      
        justify-content: center;
        padding: 8px 0;
        color:white;
        
      `}
  `;

  const LanguageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color:#3c4142;
  width:100%;
  color: white;
  padding: 10px 12px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;

    &:hover {
    background: linear-gradient(to left, rgb(50, 55, 56), rgb(55, 99, 80)); /* Apply hover effect here */
  }
`;
  const Container = styled.div`
    display: flex;
    flex-direction: column;
    width:100%;
    border-radius: 8px;
    margin:0px 7px;
  `;
  const Flex = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  `;
const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  position: relative;
  z-index: 1;
`;
const IconWrapperSupport = styled.div`
display: flex;
align-items: center;
justify-content: center;
background-color: #57D219;
border-radius: 50%;
width: 40px;
height: 40px;
margin-right: 12px;
`;

const IconWrapperTelegram = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #24A1DE;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 12px;
`;

const Text = styled.span`
color: white;
font-size: 14px;
font-weight: 500;
 display:${props => props.isCollapsed ? 'none' : 'block'};

`;
const Icon = styled.img`
  width: 40px;
  height: 40px;
`;

const Label = styled.span`
  font-size: 20px !important;
  font-weight: 30px;
  position: relative;
  
  // border:1px solid green;
  z-index: 1;
`;


const SupportButton = styled.button`
display: flex;
align-items: center;
background-color: #27272a;
border: none;
border-radius: 20px;
padding-right: 20px;
cursor: pointer;
transition: background-color 0.2s;

&:hover {
  background-color: #2a2a2a;
}
`;
const Divider = styled.div`
  height: 1px;
  background-color: #353535;
  margin: 8px 16px;
`;

const LogoWrapper = styled.div`
  // padding: 20px;
  // text-align: center;
`;
const StyledChevronRight = styled(ChevronRight)`
color: #9ca3af;
display: ${props => props.isCollapsed ? 'none' : 'block'};
`;

const SwitcherContainer = styled.div`
  display: flex;
  // background-color: #1F2937;
  border-radius: 9999px;
  // padding: 4px;
  width:100%;
`;

const SidebarTop = styled.div`
  background-color:rgb(30, 32, 36);
  width: 100% !important;
  padding: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  color: #fff;
  display: flex;
  position:relative;

`;

const Tab = styled.div`
  padding: 8px 28px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
  width:40% !important;
  text-align:center;
  transition: background-color 0.3s, color 0.3s;
  
  ${props => props.active ? `
    background-color: #31343c;
    color: white;
  ` : `
    color: #9CA3AF;
    &:hover {
      color: white;
    }
  `}
`;

const XButton=styled(X)`
position:absolute;
top:18px;
right:14px;
z-index:100;

`


const DropdownMenu = styled.div`
align-items: center;
color: white;
padding: 2px 8px;
cursor: pointer;
position: relative;
margin-top: 5px;
margin: 5px 7px;
border-radius: 5px;
// background-color:#000;
width: 100%;
// border:1px solid brown;
text-decoration: none;
font-weight: normal;
font-style: normal;
padding: 2px 0px;
display: ${(props) => (props.isOpen ? 'block' : 'none')};
// background-color: #3a4142;
border-bottom-left-radius: 8px;
border-bottom-right-radius: 8px;
margin-top: -6px;  
width:97%;
// margin-left: 10px;
// margin-right: 10px
font-weight: ${(props) => (props.isVIP || props.isPromotion ? 'bold' : 'normal')};
font-style: ${(props) => (props.isVIP ? 'italic' : 'normal')};


`;


const ButtonText = styled.span`
padding:0px 10px;
display: ${props => props.isCollapsedMobile ? 'block' : 'block'};
}
`;

const MobileMenu = ({isCollapsedMobile,  setIsCollapsedMobile}) => {
  const location = useLocation();
  const history = useHistory();
  const sidebarRef = useRef(null);
  const [activeTab, setActiveTab] = useState('Casino');
  const tabs = ['Casino', 'Sports'];
 const [lotteryDropdownOpen, setLotteryDropdownOpen] = useState(false); // State to control dropdown
  const [loaded, setLoaded] = useState(false);
  const [settings, setSettings] = useState()


  // const menuItems = [
  //   { name: 'Home', icon: 'https://static.nanogames.io/assets/home.e1cf89b4.png', path: '/' },
  //   { name: 'Originals', icon: 'https://static.nanogames.io/assets/originalcasino.bb7966a7.png', path: '/originals' },
  //   { name: 'Lottery', icon: 'https://static.nanogames.io/assets/lottery.bc95b607.png', path: '/lottery' },
  //   { name: 'Slots', icon: 'https://static.nanogames.io/assets/slots.42749df8.png', path: '/slots' },
  //   { name: 'Live Casino', icon: 'https://static.nanogames.io/assets/livecasino.80cdfcc2.png', path: '/live-casino' },
  //   { name: 'Promotions', icon: 'https://static.nanogames.io/assets/promotion.316446ec.png', color: 'rgb(93, 219, 28)', path: '/promotions' },
  //   { divider: true },
  //   { name: 'Most Populars', icon: 'https://static.nanogames.io/assets/myfavorite.466f0741.png', path: '/populars' },
  //   { name: 'Rakeback', icon: 'https://static.nanogames.io/assets/slots.42749df8.png', path: '/rakeback' },
 
  //   { name: 'Affiliate', icon: 'https://static.nanogames.io/assets/affiliate.6f434c33.png', path: '/affiliate' },
  //   { name: 'VIP Club', icon: 'https://static.nanogames.io/assets/vipclub.3b37e72c.png', color: 'rgb(235, 93, 15)', path: '/vip-club' },
  //   { name: 'Provably Fair', icon: 'https://static.nanogames.io/assets/fairness.12d49bfb.png', color: 'rgb(235, 93, 15)', path: '/provably-fair' },

  //   { divider: true },
  //   { name: 'About Us', icon: 'https://static.nanogames.io/assets/fairness.12d49bfb.png', color: 'rgb(93, 219, 28)', path: '/about-us' },
  //   { name: 'FAQ', icon: 'https://static.nanogames.io/assets/livecasino.80cdfcc2.png', color: 'rgb(93, 219, 28)', path: '/faq' },
 

  // ];


  const menuItems = [
   
    { name: 'Home',
       icon: REACT_APP_SM_LOGO,
        path: '/' },
        {
      name: "Sports",
      icon: "/assets/bcimages/Casino/slot.svg",
      path: "/casino/sports"
      },
    { name: 'Casino', icon: '/assets/bcimages/sidebar/svgexport-1.svg', path: '/casino' ,
    hasSubMenu: true,
      subMenu: [
        { name: 'Originals', icon: '/assets/bcimages/sidebar/bc-original.svg', path: '/casino/originals' },
        { name: 'Hot Games', icon: '/assets/bcimages/sidebar/icon/hot-games.svg', path: '/casino/hot-games' },
        { name: 'Slots', icon: '/assets/bcimages/sidebar/icon/slot.svg', path: '/casino/slots' },
        { name: 'Live Casino', icon: '/assets/bcimages/sidebar/icon/live-casino.svg', path: '/casino/live-casino' },
        // { name: 'Game Show', icon: '/assets/bcimages/sidebar/icon/gameShow.svg', path: '/casino/game-show' },
        // { name: 'Table Games', icon: '/assets/bcimages/sidebar/icon/table-games.svg', path: '/casino/table' },
        { name: 'Provider', icon: '/assets/bcimages/sidebar/icon/providers.svg', path: '/casino/providers' },
   
      ]
    },
    

    { name: 'Promotions', icon: '/assets/bcimages/sidebar/promotion.svg', color: 'rgb(93, 219, 28)', path: '/promotions' },
    { divider: true },
    { name: 'Rakeback', icon: '/assets/bcimages/sidebar/Lottery.svg', path: '/rakeback' },
    { name: 'Affiliate', icon: '/assets/bcimages/sidebar/affiliate.svg', path: '/affiliate' },
    { name: 'VIP Club', icon: '/assets/bcimages/sidebar/vip.svg', color: 'rgb(235, 93, 15)', path: '/vip-club' },
    { name: 'Bonus', icon: '/assets/bcimages/bcheader/gift_icon.svg', color: 'rgb(235, 93, 15)', path: '/bonus' },
    { name: 'Provably Fair', icon: '/assets/bcimages/sidebar/probablyfair.svg', color: 'rgb(235, 93, 15)', path: '/provably-fair' },

    { divider: true },
    { name: 'About Us', icon: 'https://static.nanogames.io/assets/myfavorite.466f0741.png', color: 'rgb(93, 219, 28)', path: '/about-us' },
    { name: 'FAQ', icon: 'https://static.nanogames.io/assets/livecasino.80cdfcc2.png', color: 'rgb(93, 219, 28)', path: '/faq' },
  ];
  const handleMenuItemClick = (path) => {
    history.push(path);
    setIsCollapsedMobile(false);
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsCollapsedMobile(false);
    }
  };


  const icons = {
    telegram: "/assets/images/telegram.webp",
    whatsapp: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/2044px-WhatsApp.svg.png",
    email: "/assets/images/email.webp",
    facebook: "/assets/images/facebook.webp",
    instagram: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png",
    youtube: "/assets/images/youtube.webp",
    viber: "/assets/images/viber.webp",
  };



 const fetchSettings = async () => {
  try {
    const response = await axios.get(`${API}/admin/websiteconfig`);
   const data = response.data;

  console.log(data.data.contactChannels.social);
  if (data?.data?.contactChannels?.social) {
    setSettings(data?.data?.contactChannels?.social);
  }
  } catch (error) {
    console.error("Error fetching payment settings:", error);
  }
};

function telegramLink() {
  const telegram = settings?.social?.find(
    (item) => item.platform === "telegram" && item.is_active
  );
  
  if (telegram?.value) {
    // Remove accidental spaces in the URL
    const cleanUrl = telegram.value.replace(/\s+/g, "");
    window.location.href = cleanUrl;
  } else {
    console.warn("No active Telegram link found");
  }
}


    useEffect(() => {
       fetchSettings();
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
   
  }, []);

  return (
    <>
   
      <Overlay isCollapsedMobile={isCollapsedMobile} onClick={() => setIsCollapsedMobile(false)} />
      <SidebarContainer isCollapsedMobile={isCollapsedMobile} ref={sidebarRef} >
      <XButton size={25} onClick={()=>setIsCollapsedMobile(false)}>

      </XButton>

      <SidebarTop>
      <SwitcherContainer>
      <div className='bc-logo'>
       
            <img src={REACT_APP_LG_LOGO} className='bc-logo' style={{width:"60%"}}/>
            </div>
        {/* {tabs.map(tab => (
          <Tab
            key={tab}
            active={activeTab === tab}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </Tab>
        ))} */}
      </SwitcherContainer>
    

      </SidebarTop>
        {/* {menuItems.map((item, index) =>
          item.divider ? (
            <Divider key={`divider-${index}`} />
          ) : (
            <MenuItemLink
              key={item.name}
              to={item.path}
              active={location.pathname === item.path}
              color={item.color}
              onClick={() => handleMenuItemClick(item.path)}
            >
              <IconWrapper active={location.pathname === item.path}>
                <Icon src={item.icon} alt={item.name} />
              </IconWrapper>
              {isCollapsedMobile && <Label active={location.pathname === item.path}>{item.name}</Label>}
            </MenuItemLink>
          )
        )} */}


          <div>
                {menuItems.map((item, index) =>
          item.divider ? (
            <Divider key={`divider-${index}`} isCollapsedMobile={isCollapsedMobile} />
          ) : item.hasSubMenu ? (
            <div key={item.name}>
              <MenuItemLink
                to={item.path}
                active={
                  location.pathname === item.path || 
                  item.subMenu.some((subItem) => location.pathname === subItem.path)
                } // Check if the current path matches the parent or any submenu path
                color={item.color}
                isCollapsedMobile={isCollapsedMobile}
                onClick={() => setLotteryDropdownOpen(!lotteryDropdownOpen)} // Toggle dropdown on click
              >
                <IconWrapper
                  active={
                    location.pathname === item.path || 
                    item.subMenu.some((subItem) => location.pathname === subItem.path)
                  }
                  isCollapsedMobile={isCollapsedMobile}
                >
                  <Icon src={item.icon} alt={item.name}   style={{ width: "25px", height: "25px" }} />
                </IconWrapper>
        
                <Label
                  active={
                    location.pathname === item.path || 
                    item.subMenu.some((subItem) => location.pathname === subItem.path)
                  }

                  isCollapsedMobile={isCollapsedMobile}
                  style={{ width: "100%",display:"flex",justifyContent:"space-between",textAlign:"center",alignItems:"center"}}
                >
                  <span
                    className="game-fonts text-font"
                    style={{ color: "white",fontWeight: "bold" }}
                  >
                    {item.name}
                  </span>
                  {/* Arrow icon */}
                  <span
                    style={{
                      padding: "4px",
                      backgroundColor: "#464f50",
                      borderRadius: "3px",
                      // marginLeft: "70%",
                      fontWeight: "bolder",
                    }}
                    className='arrow-icon'
                  >
                    <IoIosArrowDown
                      isOpen={lotteryDropdownOpen} // Pass the state for rotation
                      style={{
                        color: "white",
                        fontSize: "18px",
                        fontWeight: "bolder",
                        transition: "transform 0.3s ease", // Smooth transition
                        transform: lotteryDropdownOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)", // Rotate when open
                      }}
                    />
                  </span>
                </Label>
              </MenuItemLink>
        
              {/* Dropdown menu for the Lottery section */}
              <DropdownMenu isOpen={lotteryDropdownOpen}>
                {item.subMenu.map((subItem, subIndex) => (
                  <MenuItemLink
                    key={`sub-item-${subIndex}`}
                    to={subItem.path}
                    onClick={()=>setIsCollapsedMobile(false)}
                    active={location.pathname === subItem.path} // Apply active state
                    style={{
                     padding:"4px 0px",
                     margin:"2px 0px",
                     width:"100%",
                    //  border:"1px solid pink",
                     backgroundColor:
                     location.pathname === subItem.path ? "#333" : "#000",
                    }}
                    
                  >
                     <IconWrapper>
                      <Icon
                  src={subItem.icon}
                  alt={subItem.name}
                  style={{ width: "25px", height: "25px" }}
                />
                </IconWrapper>
                    <Label
                      active={location.pathname === subItem.path}
                      isCollapsedMobile={isCollapsedMobile}
                    >
                     
                <span
                 className="game-fonts text-font"
                 style={{ color: "white",  fontWeight: "bold" }}
                >
                 {subItem.name}
                </span>
                    
                    </Label>
                  </MenuItemLink>
                ))}
              </DropdownMenu>
            </div>
          ) : (
            <MenuItemLink
              key={item.name}
              to={item.path}
              active={location.pathname === item.path}
              color={item.color}
              onClick={()=>setIsCollapsedMobile(false)}
              isCollapsedMobile={isCollapsedMobile}
              style={{

                backgroundColor: location.pathname === item.path ? "#333" : "transparent",
              }}
            >
              <IconWrapper
                active={location.pathname === item.path}
                isCollapsedMobile={isCollapsedMobile}
              >
                <Icon
                  src={item.icon}
                  alt={item.name}
                  style={{ width: "25px", height: "25px" }}
                />
              </IconWrapper>
              <Label active={location.pathname === item.path} isCollapsedMobile={isCollapsedMobile}>
                <span
                  className="game-fonts text-font"
                  style={{ color: "white", fontWeight: "bold" }}
                >
                  {item.name}
                </span>
              </Label>
            </MenuItemLink>
          )
        )}

        
        </div>

        
        <Divider />

        <Flex style={{marginTop:'15px', marginBottom:'15px'}}>
          <Container onClick={()=>setIsCollapsedMobile(false)}>
            {/* <Title>Language Options</Title> */}
            <LanguageButton >
              <div style={{display:"flex",gap:"5px",textAlign:"center",alignItems:"center"}}>
              <TbWorld size={25} />
              
              <ButtonText isCollapsedMobile={isCollapsedMobile} className='game-fonts text-font' style={{fontWeight:"bold"}} >English</ButtonText>
              </div>

              <StyledChevronRight isCollapsedMobile={isCollapsedMobile} size={24} />
            </LanguageButton>
          </Container>
        </Flex>

        <Divider />

      {settings && settings.length>0 && settings
          .filter((s) => s.is_active) // only active platforms
          .map((s, index) => (
            <Flex key={index}
              style={{ marginTop: "20px", marginBottom: "20px" }}>
              <SupportButton onClick={() => window.open(s.value, "_blank")}>
                <IconWrapperTelegram>
                  <img style={{ width: "30px" }} src={icons[s.platform]} />
                </IconWrapperTelegram>
                <Text isCollapsedMobile={isCollapsedMobile} className='game-fonts text-font' style={{ fontWeight: "bold" }}>
                  {s.platform.charAt(0).toUpperCase() + s.platform.slice(1)}
                </Text>
              </SupportButton>
            </Flex>
          ))}

      </SidebarContainer>
    </>
  );
};

export default MobileMenu;